/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	InjectionToken
} from '@angular/core';
import {
	EntityService
} from '@entity/services/entity.service';
import {
	ChartFactory
} from '@shared/factories/chart-factory';
import {
	OptionsFactory
} from '@shared/factories/options-factory';
import {
	ActivityService
} from '@shared/services/activity.service';
import {
	GenesysChatService
} from '@shared/services/genesys-chat.service';
import {
	NavigationService
} from '@shared/services/navigation.service';
import {
	RuleService
} from '@shared/services/rule.service';
import {
	SessionService
} from '@shared/services/session.service';
import {
	UserService
} from '@shared/services/user.service';

/*
 * Export all tokens to be used in the dependency injector for
 * string based resolution
*/
export const activitytServiceToken =
	new InjectionToken<ActivityService>(
		'ActivityService');
export const chartFactoryToken =
	new InjectionToken<ChartFactory>(
		'ChartFactory');
export const ruleServiceToken =
	new InjectionToken<RuleService>(
		'RuleService');
export const entityServiceToken =
	new InjectionToken<EntityService>(
		'EntityService');
export const genesysChatServiceToken =
	new InjectionToken<GenesysChatService>(
		'GenesysChatService');
export const sessionServiceToken =
	new InjectionToken<SessionService>(
		'SessionService');
export const userServiceToken =
	new InjectionToken<UserService>(
		'UserService');
export const optionsFactoryToken =
	new InjectionToken<OptionsFactory>(
		'OptionsFactory');
export const navigationServiceToken =
	new InjectionToken<NavigationService>(
		'NavigationService');

/**
 * A lookup to be shared accross the application used
 * for classes available in the shared module.
 *
 * @export
 * @class SharedTokenLookup
 */
export class SharedTokenLookup
{
	/**
	 * Dictionary to be used in dependency injector for
	 * string based resolution.
	 *
	 * @static
	 * @memberof SharedTokenLookup
	 */
	public static readonly tokens =
		{
			'ActivityService':
				activitytServiceToken,
			'ChartFactory':
				chartFactoryToken,
			'RuleService':
				ruleServiceToken,
			'EntityService':
				entityServiceToken,
			'GenesysChatService':
				genesysChatServiceToken,
			'SessionService':
				sessionServiceToken,
			'UserService':
				userServiceToken,
			'OptionsFactory':
				optionsFactoryToken,
			'NavigationService':
				navigationServiceToken
		};
}